import axios from 'axios';
import {
	GET_AP_LIST,
	ENDPOINT_URL,
	API_RESPONSE_SUCCESS_STATUS_CODE,
	AUTH_TOKEN_ERROR_STATUS_CODE,
	AUTH_TOKEN_ERROR_STATUS_MSG,
	TOKEN_FAILED,
	DELETE_AP,
	API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS,
	// POST_API_RESPONSE_SUCCESS_STATUS_CODE,
	UPDATE_AP,
	MOVE_AP_ENDPOINT,
	GET_DEVICE_FIRMWARE_MODELS_LIST,
	// APRECOMM_NOTIFICATION_URL,
	GET_DEVICE_LIST_BY_SITE,
	GET_APSWITCH_LIST,
	API_SUCCESS_CODES,
	TURN_LED_OFF,
	TURN_LED_ON,
	WPS_NOTIF,
	AP_BLINK_ENDPOINT,
	DOWNLOAD_AP_CSV_EXCEL,
	CONFIG_AUDIT_API,
	GET_NESTED_CHILD_LIST_BY_SITE
} from '../../constants/commonConstants';
import {
	AP_DELETE_FAIL,
	AP_DELETE_SUCCESS,
	// ADD_AP_RESULT,
	AP_LIST_GET_FAIL,
	AP_LIST_GET_SUCCESS,
	AP_REQUEST_DELETE,
	AP_LIST_REQUEST_GET,
	BULK_ADD_AP_RESPONSE_SUCCESS,
	// BULK_ADD_AP_SUCCESS_MSG_RESPONSE,
	BULK_AP_REQUEST_POST,
	BULK_AP_RESPONSE_POST_FAIL,
	AP_REQUEST_ADD,
	AP_ADD_SUCCESS,
	AP_ADD_FAIL,
	AP_REQUEST_UPDATE,
	AP_UPDATE_SUCCESS,
	AP_UPDATE_FAIL,
	AP_SEARCH_GET_FAIL,
	AP_SEARCH_GET_SUCCESS,
	AP_SEARCH_REQUEST_GET,
	POST_MOVE_AP_FAIL,
	POST_MOVE_AP_SUCCESS,
	POST_MOVE_AP,
	AP_FIRMWARE_REQUEST_GET,
	AP_FIRMWARE_GET_FAIL,
	AP_FIRMWARE_GET_SUCCESS,
	DEVICE_REQUEST_BY_SITE_GET,
	DEVICE_RESPONSE_BY_SITE_GET_SUCCESS,
	DEVICE_RESPONSE_BY_SITE_GET_FAIL,
	APSWITCH_REQUEST_GET,
	APSWITCH_RESPONSE_GET_SUCCESS,
	APSWITCH_RESPONSE_GET_FAIL,
	DOWNLOAD_AP_FILE,
	DOWNLOAD_AP_SUCCESS,
	DOWNLOAD_AP_FAIL,
	CONFIG_AUDIT_ADD,
	CONFIG_AUDIT_ADD_SUCCESS,
	CONFIG_AUDIT_ADD_FAIL,
	CONFIG_AUDIT_LIST_REQUEST_GET,
	CONFIG_AUDIT_LIST_GET_SUCCESS,
	CONFIG_AUDIT_LIST_GET_FAIL,
	CONFIG_AUDIT_DELETE,
	CONFIG_AUDIT_DELETE_SUCCESS,
	CONFIG_AUDIT_DELETE_FAIL,
	DOWNLOAD_CONFIG_AUDIT,
	DOWNLOAD_CONFIG_AUDIT_SUCCESS,
	DOWNLOAD_CONFIG_AUDIT_FAIL,
	CHILD_LIST_REQUEST_BY_SITE_GET,
	CHILD_LIST_RESPONSE_BY_SITE_GET_SUCCESS,
	CHILD_LIST_RESPONSE_BY_SITE_GET_FAIL

} from '../../constants/accessPointConstants';
import { logout } from '../userActions';
import { decryptData, encryptData } from '../../utils/crypto';
import {
	notifyUpdateRouterToAprecom,
	moveApAprecomApi,
	notifyBulkAddRouterToAprecomApi,
	notifyRouterToAprecom,
	notifyDeleteRouterToAprecom,
} from '../apiToNotifyAprecom';
import { moveAPFromT4 } from '../../actions/ssid/urlFilteringAction';
import { getErrorMsgFromApiResp } from '../../utils/utility';

/**
 * Action creator for listing access points.
 *
 * This function asynchronously dispatches actions to fetch a list of access points.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {number} [limit=50] - Optional parameter specifying the maximum number of groups to fetch.
 * @param {number} [offset=0] - Optional parameter specifying the page no. to fetch the entries from that particular page.
 * @param {string} siteId - Site Id , if devices are to be filtered by group in dashboard
 * @param {string} search - search , if devices are to be filtered by specific string in dashboard
 * @param {number} [status=1] - status,  if devices are to be filtered by status in dashboard
 * @param {Array} [firmware] - firmwares,  if devices are to be filtered by firmwares in dashboard
 * @param {Array} [group] - group,  if devices are to be filtered by group in dashboard
 * @param {Array} [model] - model,  if devices are to be filtered by models in dashboard
 * @param {boolean} [selectAll] - selectAll,  pass group as selectAll if all the sites are selected
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getApList =
	(limit, offset = 0, siteId, search, status, firmware, group, model,selectAll) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: AP_LIST_REQUEST_GET,
			});

			let url =
				ENDPOINT_URL +
				GET_AP_LIST +
				'?limit=' +
				limit +
				'&offset=' +
				offset;

			const groupsQueryParam = group?.join(',');
			if (groupsQueryParam) {
				if (selectAll == true){
					url = url + '&group=selectall'
				}else{
					url += '&group=' + groupsQueryParam;
				}
			}
			const firmwareQueryParam = firmware?.join(',');
			if (firmwareQueryParam) {
				url += '&firmware=' + firmwareQueryParam;
			}
			const modelQueryParam = model?.join(',');
			if (modelQueryParam) {
				url += '&model=' + modelQueryParam;
			}

			if (siteId) {
				url = url + '&group=' + siteId;
			}
			if (search) {
				url = url + '&search=' + search;
			}
			if (status === 0 || status === 1) {
				url = url + '&status=' + status;
			}
			const config = {
				method: 'get',
				maxBodyLength: Infinity,
			url: url,
		};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('in get ap list...', data);
			if (
				data &&
				data.status &&
				API_SUCCESS_CODES?.includes(data?.status)
			) {
				dispatch({
					type: AP_LIST_GET_SUCCESS,
					payload: data,
				});
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: AP_LIST_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: AP_LIST_GET_FAIL,
				payload: message,
			});
		}
	};

export const deleteAp = (body, selectAll, siteId) => async (dispatch, getState) => {
	try {
		dispatch({
			type: AP_REQUEST_DELETE,
		});
		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		let url = ENDPOINT_URL + DELETE_AP;
		if (selectAll) {
			url += `?selectall=true`;
		}
		const config = {
			method: 'put',
			maxBodyLength: Infinity,
			url: url,
			data: ciphertext,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('aprecomAddSiteData', data, body, siteId);
		if (data && data.status && API_SUCCESS_CODES?.includes(data?.status)) {
			dispatch({
				type: AP_DELETE_SUCCESS,
				payload: data.data,
				msg: data?.msg,
				length: body.serial_no?.length,
			});
			dispatch(getApList(5, 0, siteId));
			dispatch(notifyDeleteRouterToAprecom(body));
			return true;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: AP_DELETE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
			return false;
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch({
				type: AP_DELETE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
			return false;
		}
		return false;
	}
};

export const addAp = (body, siteId) => async (dispatch, getState) => {
	try {
		dispatch({
			type: AP_REQUEST_ADD,
		});
		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_AP_LIST,
		data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('in get ap list...', data);
		if (data && data.status && API_SUCCESS_CODES?.includes(data?.status)) {
			dispatch({
				type: AP_ADD_SUCCESS,
				payload: data.data,
			});
			dispatch(getApList(5, 0, siteId));
			dispatch(
				notifyUpdateRouterToAprecom({
					serialNumber: body?.serial_no,
					routerName: data?.data?.ap_name,
					siteName: data.data?.siteName,
				})
			);

			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch(logout());
		}
		if (data && data.error) {
			const errorMessage = getErrorMsgFromApiResp(data.error);
			dispatch({
				type: AP_ADD_FAIL,
				payload: errorMessage,
			});
			return { ...data, error: errorMessage };
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch({
				type: AP_ADD_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
		return error;
	}
};

export const updateAp = (body, serialNo) => async (dispatch, getState) => {
	try {
		dispatch({
			type: AP_REQUEST_UPDATE,
		});
		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);
		let url = ENDPOINT_URL + UPDATE_AP;
		if (serialNo) {
			url = url + serialNo + '/';
		}
		const config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: url,		
			data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (data && data.status && API_SUCCESS_CODES?.includes(data?.status)) {
			dispatch({
				type: AP_UPDATE_SUCCESS,
				payload: data,
			});
			// notify apprecom if ap name changed
			if (data?.data?.serial_no && body?.ap_name) {
				const apprecomPayload = {
					serialList: [{ serialNumber: data?.data?.serial_no }],
					siteName: data?.data?.siteName,
					routerName: body?.ap_name,
				};

				dispatch(notifyRouterToAprecom(apprecomPayload));
			}
			return data;
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			//  &&
			// data.error &&
			// data.error === AUTH_TOKEN_ERROR_STATUS_MSG
		) {
			dispatch(logout());
			return data;
		} else if (data && (data.error || data.errors)) {
			dispatch({
				type: AP_UPDATE_FAIL,
				payload: data.error || data.errors,
			});
			return data;
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch({
				type: AP_UPDATE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
		return { error };
	}
};

export const bulkAddAP = (payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: BULK_AP_REQUEST_POST,
		});

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);
		const config = {
			method: 'post',
			url: ENDPOINT_URL + GET_AP_LIST,
		data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.data &&
			data.status &&
			API_SUCCESS_CODES?.includes(data?.status)
		) {
			// calling group list api
			dispatch({
				type: BULK_ADD_AP_RESPONSE_SUCCESS,
				payload: { data: data.data },
				msg: data?.msg,
			});
			dispatch(notifyBulkAddRouterToAprecomApi(payload));
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: BULK_AP_RESPONSE_POST_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			data.status === API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS &&
			data.error
		) {
			dispatch({
				type: BULK_AP_RESPONSE_POST_FAIL,
				payload: data.error,
			});
			return data;
		}
	} catch (error) {
		const message =
			error.response && error.response.data && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: BULK_AP_RESPONSE_POST_FAIL,
			payload: message,
		});
	}
};

// const moveApAprecomApi = async (destSite, payload, doesSiteHaveAp) => {
// 	const APPRECOM_BASE_URL = localStorage.getItem('aprecom_url');
// 	const APPRECOM_TOKEN = localStorage.getItem('aprecom_token');

// 	if (APPRECOM_BASE_URL && APPRECOM_TOKEN) {
// 		if (doesSiteHaveAp) {
// 			const aprecomBody = {
// 				type: 'updateRouter',
// 				serialList: [
// 					{ serialNumber: payload.apSerialNums[0].apSerialNum },
// 				],
// 				siteName: destSite?.nested_site_name,
// 			};

// 			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
// 			const config = {
// 				method: 'post',
// 				maxBodyLength: Infinity,
// 				url: url,
// 				data: JSON.stringify(aprecomBody),
// 			};
// 			const { data } = await axios.request(config);
// 			console.log('MOVE data DIRECT MOVE --- ', data);
// 		} else {
// 			const APPRECOM_USER = localStorage.getItem('apreTenantName');
// 			const aprecomAddSiteBody = {
// 				type: 'addSite',
// 				custName: APPRECOM_USER,
// 				siteName: destSite?.nested_site_name,
// 				country: 'India',
// 				state: 'Karnataka',
// 				city: 'Banglore',
// 				lat: '34',
// 				long: '36'
// 			};

// 			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
// 			const aprecomAddSiteConfig = {
// 				method: 'post',
// 				maxBodyLength: Infinity,
// 				url: url,
// 				data: JSON.stringify(aprecomAddSiteBody),
// 			};
// 			const { data: aprecomAddSiteData } = await axios.request(
// 				aprecomAddSiteConfig
// 			);
// 			console.log('MOVE data ADD SITE--- ', aprecomAddSiteData);
// 			const aprecomMoveApBody = {
// 				type: 'updateRouter',
// 				serialList: [
// 					{ serialNumber: payload.apSerialNums[0].apSerialNum },
// 				],
// 				siteName: destSite?.nested_site_name,
// 			};
// 			const config = {
// 				method: 'post',
// 				maxBodyLength: Infinity,
// 				url: url,
// 				data: JSON.stringify(aprecomMoveApBody),
// 			};
// 			const { data } = await axios.request(config);
// 			console.log('MOVE data MOVE', data);
// 		}
// 	}
// 	return 'Aprecom api called';
// };

export const moveAp = (destSite, payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: POST_MOVE_AP,
		});

		const {
			userLogin: { userInfo },
		} = getState();
		
		let doesSiteHaveAp = false;
		const getApurl =
			ENDPOINT_URL +
			GET_AP_LIST +
			'?limit=' +
			5 +
			'&offset=' +
			0 +
			'&group=' +
			payload.site_id;
		const getApconfig = {
			method: 'get',
			maxBodyLength: Infinity,
			url: getApurl,
			
			};

		let { data: getApData } = await axios.request(getApconfig);
		const getApJsonString = decryptData(getApData);
		getApData = JSON.parse(getApJsonString);

		if (
			getApData &&
			getApData.status &&
			getApData.status === API_RESPONSE_SUCCESS_STATUS_CODE &&
			getApData.results.length > 0
		) {
			doesSiteHaveAp = true;
		}

		const url = ENDPOINT_URL + MOVE_AP_ENDPOINT;
		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,		
		data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.status &&
			data.status === API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			dispatch({
				type: POST_MOVE_AP_SUCCESS,
				payload: data.msg,
			});

			try {
				console.log(
					'destSite-payload-doesSiteHaveAp',
					destSite,
					payload,
					doesSiteHaveAp
				);
				await dispatch(
					moveApAprecomApi(destSite, payload, doesSiteHaveAp)
				);
				await dispatch(moveAPFromT4(userInfo, payload, destSite));
			} catch (error) {
				console.error('Error calling moveApAprecomApi:', error);
			}
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: POST_MOVE_AP_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: POST_MOVE_AP_FAIL,
			payload: message,
		});
	}
};

/**
 * Action creator for listing access points.
 *
 * This function asynchronously dispatches actions to fetch a list of access points.
 * It sends a request to the server with optional parameters such as limit.
 * Upon successful response, it dispatches an action with the retrieved data.
 * If the authentication token is invalid or expired, it dispatches a logout action.
 *
 * @param {number} [limit=50] - Optional parameter specifying the maximum number of groups to fetch.
 * @param {number} [offset=0] - Optional parameter specifying the page no. to fetch the entries from that particular page.
 * @param {string} siteId - Site Id , if devices are to be filtered by group in dashboard.
 * @param {string} search - Site Id , if devices are to be filtered by group in dashboard.
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const getGlobalApSearch =
	(limit, offset = 0, siteId, search) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: AP_SEARCH_REQUEST_GET,
			});

			let url =
				ENDPOINT_URL +
				GET_AP_LIST +
				'?limit=' +
				limit +
				'&offset=' +
				offset;
			if (siteId) {
				url = url + '&group=' + siteId;
			}
			if (search) {
				url = url + '&search=' + search;
			}
			const config = {
				method: 'get',
				maxBodyLength: Infinity,
			url: url,
		};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('in get ap list...', data);
			if (
				data &&
				data.status &&
				data.status === API_RESPONSE_SUCCESS_STATUS_CODE
			) {
				dispatch({
					type: AP_SEARCH_GET_SUCCESS,
					payload: data,
				});
				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: AP_LIST_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: AP_SEARCH_GET_FAIL,
				payload: message,
			});
		}
	};

export const getAPFirmwareAndModels = () => async (dispatch, getState) => {
	try {
		dispatch({
			type: AP_FIRMWARE_REQUEST_GET,
		});

		const url = ENDPOINT_URL + GET_DEVICE_FIRMWARE_MODELS_LIST;

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.status &&
			data.status === API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			dispatch({
				type: AP_FIRMWARE_GET_SUCCESS,
				payload: data,
			});
			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: AP_FIRMWARE_GET_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: AP_FIRMWARE_GET_FAIL,
			payload: message,
		});
	}
};

export const devicelistGroupBySite1 =
	(siteId) => async (dispatch, getState) => {
		try {
			dispatch({
				type: DEVICE_REQUEST_BY_SITE_GET,
			});

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + GET_DEVICE_LIST_BY_SITE + siteId,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			if (data && data.length > 0) {
				dispatch({
					type: DEVICE_RESPONSE_BY_SITE_GET_SUCCESS,
					payload: data, // Pass the updated data
				});

				return data; // Return data to the caller
			}

			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: DEVICE_RESPONSE_BY_SITE_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: DEVICE_RESPONSE_BY_SITE_GET_FAIL,
				payload: message,
			});
		}
	};

export const listAPSwitch = (postData) => async (dispatch, getState) => {
	try {
		dispatch({
			type: APSWITCH_REQUEST_GET,
		});

		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_APSWITCH_LIST,
			data: postData,
		};

		const { data } = await axios.request(config);
		const jsonString = decryptData(data);
		const finalResponse = JSON.parse(jsonString);
		if (finalResponse && finalResponse.results) {
			dispatch({
				type: APSWITCH_RESPONSE_GET_SUCCESS,
				payload: finalResponse,
			});
		}
		if (
			finalResponse &&
			finalResponse.status &&
			finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE &&
			finalResponse.error &&
			finalResponse.error === AUTH_TOKEN_ERROR_STATUS_MSG
		) {
			dispatch({
				type: APSWITCH_RESPONSE_GET_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error?.response && error?.response?.finalResponse?.message
				? error?.response?.finalResponse?.message
				: error?.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: APSWITCH_RESPONSE_GET_FAIL,
			payload: 'Error fetching LIST',
		});
	}
};

export const devicelistGroupBySite = (siteId) => async (dispatch, getState) => {
	try {
		dispatch({
			type: DEVICE_REQUEST_BY_SITE_GET,
		});

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + GET_DEVICE_LIST_BY_SITE + siteId,
			};

		const { data } = await axios.request(config);
		const jsonString = decryptData(data);
		const finalResponse = JSON.parse(jsonString);
		console.log(finalResponse, 'final response');
		if (finalResponse && finalResponse.results) {
			dispatch({
				type: DEVICE_RESPONSE_BY_SITE_GET_SUCCESS,
				payload: finalResponse,
			});
		}
		if (
			finalResponse &&
			finalResponse.status &&
			finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE &&
			finalResponse.error &&
			finalResponse.error === AUTH_TOKEN_ERROR_STATUS_MSG
		) {
			dispatch({
				type: DEVICE_RESPONSE_BY_SITE_GET_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error?.response && error?.response?.finalResponse?.message
				? error?.response?.finalResponse?.message
				: error?.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: DEVICE_RESPONSE_BY_SITE_GET_FAIL,
			payload: 'Error fetching LIST',
		});
	}
};
export const ledStatusOnOff =
	(ledStatus, body) => async (dispatch, getState) => {
		try {
			// dispatch({
			// 	type: AP_REQUEST_ADD,
			// });
			const jsonData = JSON.stringify(body);
			const ciphertext = encryptData(jsonData);
			let url;
			if (ledStatus === 0) {
				url = ENDPOINT_URL + TURN_LED_OFF;
			} else if (ledStatus === 1) {
				url = ENDPOINT_URL + TURN_LED_ON;
			}
			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: url,		
				data: ciphertext,
		};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('in get ap list...', data);
			if (
				data &&
				data.status &&
				API_SUCCESS_CODES?.includes(data?.status)
			) {
				// dispatch({
				// 	type: AP_ADD_SUCCESS,
				// 	payload: data.data,
				// });
				// dispatch(getApList(5, 0, siteId));
				dispatch(
					notifyUpdateRouterToAprecom({
						serialNumber: body?.serial_no,
						routerName: data?.data?.ap_name,
						siteName: data.data?.siteName,
					})
				);

				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch(logout());
			}
			if (data && data.error) {
				// dispatch({
				// 	type: AP_ADD_FAIL,
				// 	payload: data.error,
				// });
				return data;
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				// dispatch({
				// 	type: AP_ADD_FAIL,
				// 	payload: TOKEN_FAILED,
				// });
				dispatch(logout());
			}
			return error;
		}
	};
export const ledStatusOnOffTip =
	(body, serialNo) => async (dispatch, getState) => {
		try {
			// dispatch({
			// 	type: AP_REQUEST_ADD,
			// });
			const jsonData = JSON.stringify(body);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + AP_BLINK_ENDPOINT + serialNo + '/',
				data: ciphertext,
		};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('in get ap list...', data);
			if (
				data &&
				data.status &&
				API_SUCCESS_CODES?.includes(data?.status)
			) {
				// dispatch({
				// 	type: AP_ADD_SUCCESS,
				// 	payload: data.data,
				// });
				// dispatch(getApList(5, 0, siteId));
				// dispatch(
				// 	notifyUpdateRouterToAprecom({
				// 		serialNumber: body?.serial_no,
				// 		routerName: data?.data?.ap_name,
				// 		siteName: data.data?.siteName,
				// 	})
				// );

				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch(logout());
			}
			if (data && data.error) {
				// dispatch({
				// 	type: AP_ADD_FAIL,
				// 	payload: data.error,
				// });
				return data;
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				// dispatch({
				// 	type: AP_ADD_FAIL,
				// 	payload: TOKEN_FAILED,
				// });
				dispatch(logout());
			}
			return error;
		}
	};

export const triggerWPSNotif = (body) => async (dispatch, getState) => {
	try {
		// dispatch({
		// 	type: AP_REQUEST_ADD,
		// });
		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		const url = ENDPOINT_URL + WPS_NOTIF;
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,		
			data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if (data && data.status && API_SUCCESS_CODES?.includes(data?.status)) {
			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch(logout());
		}
		if (data && data.error) {
			return data;
		}
	} catch (error) {
		if (error && error.status === AUTH_TOKEN_ERROR_STATUS_CODE) {
			dispatch(logout());
		}
		return error;
	}
};

export const downloadAccessPointList =
	(downloadData) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: DOWNLOAD_AP_FILE,
			});

		const jsonData = JSON.stringify(downloadData);
			const ciphertext = encryptData(jsonData);
			// Configure request
			const config = {
				method: 'get',
				url: ENDPOINT_URL + DOWNLOAD_AP_CSV_EXCEL,
		data: ciphertext,
		};

			// Send request and get response
			const { data } = await axios.request(config);
			// const jsonString = decryptData(data);
			// data = JSON.parse(jsonString);
			// Dispatch success action with received data
			dispatch({
				type: DOWNLOAD_AP_SUCCESS,
				payload: data,
			});
			return data;
		} catch (error) {
			// Handle error
			console.error('Failed to downlaod data:', error);
			dispatch({
				type: DOWNLOAD_AP_FAIL,
				payload: error.message || 'Failed to downlaod data',
			});
			throw error;
		}
	};
// Bulk Config Audit Apis:

export const addConfigAudit = (body) => async (dispatch, getState) => {
	try {
		dispatch({
			type: CONFIG_AUDIT_ADD,
		});

		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		const url = ENDPOINT_URL + CONFIG_AUDIT_API;
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,		data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data coming...', data);

		if (data && data.status && API_SUCCESS_CODES?.includes(data?.status)) {
			dispatch({
				type: CONFIG_AUDIT_ADD_SUCCESS,
				payload: data,
			});
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch(logout());
		}
		if (data && data.error) {
			dispatch({
				type: CONFIG_AUDIT_ADD_FAIL,
				payload: data?.error,
			});
		}
		return data;
	} catch (error) {
		if (error && error.status === AUTH_TOKEN_ERROR_STATUS_CODE) {
			dispatch(logout());
		}
		return error;
	}
};

export const getConfigAudit =
	(limit, offset = 0, search) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: CONFIG_AUDIT_LIST_REQUEST_GET,
			});

			let url =
				ENDPOINT_URL +
				CONFIG_AUDIT_API +
				'?limit=' +
				limit +
				'&offset=' +
				offset;
			if (search) {
				url = url + '&search=' + search;
			}
			const config = {
				method: 'get',
				maxBodyLength: Infinity,
			url: url,
		};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('in get audit list...', data);
			if (
				data
			) {
				dispatch({
					type: CONFIG_AUDIT_LIST_GET_SUCCESS,
					payload: data,
				});
				return data;
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: CONFIG_AUDIT_LIST_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: CONFIG_AUDIT_LIST_GET_FAIL,
				payload: message,
			});
		}
	};

export const deleteConfigAudit = (body) => async (dispatch, getState) => {
	try {
		dispatch({
			type: CONFIG_AUDIT_DELETE,
		});
		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + CONFIG_AUDIT_API,
		data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (data && data.status && API_SUCCESS_CODES?.includes(data?.status)) {
			dispatch({
				type: CONFIG_AUDIT_DELETE_SUCCESS,
				payload: data,
			});
			return data;
		} else if(data && data.error) {
			dispatch({
				type: CONFIG_AUDIT_DELETE_FAIL,
				payload: data?.error,
			});
			return data;
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: CONFIG_AUDIT_DELETE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
			return data;
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch({
				type: CONFIG_AUDIT_DELETE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
		return message;
	}
};

export const downloadConfigAudit = (auditId) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: DOWNLOAD_CONFIG_AUDIT,
			});

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + CONFIG_AUDIT_API + 'download/' + auditId + '/',
			};

			const { data } = await axios.request(config);
			// const jsonString = decryptData(data);
			// data = JSON.parse(jsonString);
			console.log('in get audit list...', data);
			if (
				data
			) {
				dispatch({
					type: DOWNLOAD_CONFIG_AUDIT_SUCCESS,
					payload: data,
				});
			}
			if (data && data.error) {
				dispatch({
					type: DOWNLOAD_CONFIG_AUDIT_FAIL,
					payload: data?.error,
				});
			}
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: DOWNLOAD_CONFIG_AUDIT_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
			return data;
		} catch (error) {
            let message = "Something went wrong";

            try {
                if (error.response && error.response.data) {
                    const jsonString = decryptData(error.response.data);
                    const parsed = JSON.parse(jsonString);
                    message = parsed.error || parsed.message || error.message;
                } else {
                    message = error.message;
                }
            } catch (decryptErr) {
                message = error.message;
            }

            console.log("error ", message);

            if (message === TOKEN_FAILED) {
                dispatch(logout());
            }

            dispatch({
                type: DOWNLOAD_CONFIG_AUDIT_FAIL,
                payload: message,
            });

            return { error: message };
        }
	};

	export const roleListChildByParentSite =
	(postData) => async (dispatch) => {
		try {
			dispatch({ type: CHILD_LIST_REQUEST_BY_SITE_GET })

			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + GET_NESTED_CHILD_LIST_BY_SITE,
				data: postData,
			};
			
			const { data } = await axios.request(config);
			const jsonString = decryptData(data);
			const finalResponse = JSON.parse(jsonString)

			if (finalResponse && finalResponse.results) {
				dispatch({
					type: CHILD_LIST_RESPONSE_BY_SITE_GET_SUCCESS,
					payload: finalResponse,
				});
				// Return the results array for direct use in component
				return finalResponse.results;
			}
			
			// If response is directly an array
			if (Array.isArray(finalResponse)) {
				dispatch({
					type: CHILD_LIST_RESPONSE_BY_SITE_GET_SUCCESS,
					payload: { results: finalResponse },
				});
				return finalResponse;
			}
			
			return [];
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			dispatch({
				type: CHILD_LIST_RESPONSE_BY_SITE_GET_FAIL,
				payload: message || 'Error fetching LIST',
			});
			return [];
		}
	};
